var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAccordionOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 11C22.448 11 22 11.448 22 12C22 17.514 17.514 22 12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2C14.6845 2 17.2045 3.049 19.096 4.954C19.485 5.3455 20.1185 5.348 20.51 4.959C20.902 4.57 20.904 3.9365 20.515 3.5445C18.2455 1.259 15.221 0 12 0C5.383 0 0 5.383 0 12C0 18.617 5.383 24 12 24C18.6165 24 24 18.617 24 12C24 11.448 23.552 11 23 11Z",
    fill: "#004E5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.414 12L15.707 9.707C16.0975 9.3165 16.0975 8.6835 15.707 8.293C15.3165 7.9025 14.6835 7.9025 14.293 8.293L12 10.586L9.707 8.293C9.317 7.9025 8.683 7.9025 8.293 8.293C7.9025 8.6835 7.9025 9.3165 8.293 9.707L10.586 12L8.293 14.293C7.9025 14.6835 7.9025 15.3165 8.293 15.707C8.488 15.9025 8.744 16 9 16C9.256 16 9.512 15.9025 9.707 15.707L12 13.414L14.293 15.707C14.4885 15.9025 14.744 16 15 16C15.256 16 15.5115 15.9025 15.707 15.707C16.0975 15.3165 16.0975 14.6835 15.707 14.293L13.414 12Z",
    fill: "#004E5E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionOpen);
export default __webpack_public_path__ + "static/media/AccordionOpen.456ba948e57b977a994dc52c8a1ce6b1.svg";
export { ForwardRef as ReactComponent };